import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateCreateEmployer = {
  createEmployer: { data: null, loading: false, error: null },
};

export const createEmployer = createAsyncThunk('user/createEmployer', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .post(`${process.env.REACT_APP_SERVER_API}/employers/`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerCreateEmployer = {
  [createEmployer.pending]: (state) => {
    state.createEmployer.loading = true;
    state.createEmployer.error = null;
  },
  [createEmployer.fulfilled]: (state, action) => {
    state.createEmployer.loading = false;
    state.createEmployer.data = action.payload;
    state.createEmployer.error = null;
  },
  [createEmployer.rejected]: (state, action) => {
    state.createEmployer.loading = false;
    state.createEmployer.error = action.payload;
  },
};
